let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lzqPA")).then(() => parcelRequire('3Y5kJ'));